<script>
export default {
  name: "SmallModal",
  methods: {
    checkModal() {
      this.$emit("checkModal");
      //this.$parent.clickCheckByModal();
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss"  />
